// extracted by mini-css-extract-plugin
export var chevron = "_kc-4";
export var chevronExpanded = "_kc-5";
export var row = "_kc-0";
export var rowBody = "_kc-6";
export var rowDescription = "_kc-7";
export var rowHeader = "_kc-1";
export var rowTitle = "_kc-2";
export var rowTitleComplete = "_kc-3";